import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, pipe, share, tap } from 'rxjs';
import { ApiConstants } from '../../../../shared/constants/api-constants';
import { NameCode } from '../../../../shared/models/name-code';
import { TrainingItemGroupsLookupRequest } from '../models/training-item-groups-lookup-request';
import { UpdateTrainingItemGroupsRequest } from '../models/update-training-item-groups-request';

@Injectable({
  providedIn: 'root'
})
export class TrainingItemGroupManagementService {
  trainingItemGroups : NameCode[] = [];
  trainingItemGroupsObservable!:Observable<any>;

  constructor(private httpClient : HttpClient) {
    
   }
   
   updateTrainingItemGroups(updateTrainingItemGroupsRequest: UpdateTrainingItemGroupsRequest) {
    return this.httpClient.post<string[]>(ApiConstants.TrainingItemGroup_Update, updateTrainingItemGroupsRequest);
  }

   getTrainingItemGroupsLookup(request : TrainingItemGroupsLookupRequest) : Observable<any>{
     let observable : Observable<any>;
    if (this.trainingItemGroups.length > 0) {
      observable = of(this.trainingItemGroups);
    }else if(this.trainingItemGroupsObservable){
      observable = this.trainingItemGroupsObservable;
    }
    else {
      this.trainingItemGroupsObservable = this.httpClient.post<NameCode[]>(ApiConstants.TrainingItemGroup_LookUp, request)
        .pipe(
          tap(response => this.trainingItemGroups = response),
          share()
        );
        observable = this.trainingItemGroupsObservable;
    }
    return observable;
  }
}
